import { render } from "./wcPage.vue?vue&type=template&id=7a8d1fcb&scoped=true"
import script from "./wcPage.vue?vue&type=script&lang=js"
export * from "./wcPage.vue?vue&type=script&lang=js"

import "./wcPage.vue?vue&type=style&index=0&id=7a8d1fcb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8d1fcb"]])

export default __exports__